/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function (Drupal, $) {
  'use strict';

  // To understand behaviors, see https://www.drupal.org/node/2269515
  Drupal.behaviors.basic = {
    attach: function (context, settings) {

      function toggleShowSearch(e) {
        console.log('ok');
        e.preventDefault();
        $('body').toggleClass('show-search');
      }

      // Execute code once the DOM is ready. $(handler) not required
      // within Drupal.behaviors.


      $(window).once().on('load', function () {
      // $(document).once().ready(function () {
        // Execute code once the window is fully loaded.

        /** Fallback ObjectFit Calendar Items */
        if ( !Modernizr.objectfit ) {

          $('.calendar-item').each(function () {
            var $container = $(this).find('.views-field-field-image .field-content'),
                imgUrl = $container.find('img').prop('src');

            if (imgUrl) {
              $container
                .css('backgroundImage', 'url(' + imgUrl + ')')
                .addClass('compat-object-fit');
            }
          });

        }

        $(document).on('click','.js-class-handler', function(e) {
          const $this = $(this);
          const classToToggle = $this.attr('data-class');
          const $target = $($this.attr('data-class-target')) || $body;
          const method = $this.attr('data-class-method');

          e.preventDefault();
          // $this.toggleClass('is-active');

          if (method === "add") {
            $target.addClass(classToToggle);
          } else if (method === "remove") {
            $target.removeClass(classToToggle);
          } else if (method === "toggle") {
            $target.toggleClass(classToToggle);
          }
        });

        /** Search toggle */
        $('#header-region, #footer-region').find('a[href="#search"]').on('click', toggleShowSearch);
        $('#search-close').on('click', toggleShowSearch);

        /** Slider */
        $('#slider').slick({
          // fade: true,
          dots: false,
          prevArrow: '<button type="button" class="slick-arrow--prev"><</button>',
          nextArrow: '<button type="button" class="slick-arrow--next">></button>',
        });

        /** Slider */
        $('.single__slider-inner > div').slick({
          // fade: true,
          dots: false,
          prevArrow: '<button type="button" class="slick-arrow--prev"><</button>',
          nextArrow: '<button type="button" class="slick-arrow--next">></button>',
        });

        $('.page_standard__images').slick({
          dots: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          prevArrow: '<button type="button" class="slick-arrow--prev"><</button>',
          nextArrow: '<button type="button" class="slick-arrow--next">></button>',
        });


        var calendarElement = document.getElementById('calendar');
        if (calendarElement) {

          function getFullDate(date) {
            var day = date.getDate();
            if (day < 10) day = "0"+day;

            var month = date.getMonth() + 1;
            if (month < 10) month = "0"+month;

            var year = date.getFullYear();
            return year+'-'+month+'-'+day
          }

          window.setupCalendar = function(data) {

            var dateHovered = false;
            var popupHovered = false;
            var activeDateEl = null;

            var calendar = jsCalendar.new({
              target: calendarElement,

              date: null,
              min: "now",

              dayFormat: "DDD",
              firstDayOfTheWeek: "2",
              language: "fr",
            });



            if (data) {
              var events = {};

              data.forEach(function(data_row) {
                if (data_row.hasOwnProperty('field_date2')) {
                  var nid = data_row.nid[0].value;

                  data_row.field_date2.forEach(function(d) {
                    var date = new Date(d.value);
                    var full = getFullDate(date);
                    var hours = date.getHours();
                    if (hours < 10) hours = "0"+hours;
                    var minutes = date.getMinutes();
                    if (minutes < 10) minutes = "0"+minutes;

                    var rowId = nid+"__"+hours+"__"+minutes;


                    if (!events.hasOwnProperty(full)) {
                      events[full] = [];
                    }

                    events[full][rowId] = {
                      nid: nid,
                      title: data_row.title[0].value,
                      time: {
                        hours: hours,
                        minutes: minutes,
                      },
                      category: (data_row.field_categorie && data_row.field_categorie.length > 0 && data_row.field_categorie[0].target_id),
                      type: data_row.type[0].target_id,
                      path: data_row.path[0].alias
                    };
                  });
                }
              });

              console.log('events', events);

              function setupPopup(target, date) {
                var full = getFullDate(date);

                if (events.hasOwnProperty(full)) {

                  var $target = $(target);
                  var targetPos = $target.position();

                  if (activeDateEl) {
                    activeDateEl.classList.remove('active');
                  }
                  activeDateEl = target;
                  $target.addClass('active');

                  dateHovered = true;

                  var popupEl = document.getElementById('calendar-popup');
                  if (popupEl) popupEl.remove();

                  popupEl = document.createElement('div');
                  popupEl.id = 'calendar-popup';
                  popupEl.className = 'calendar-popup';

                  // console.log('targetPos.top', targetPos.top);
                  // console.log('$target.outerHeight()', $target.outerHeight());
                  popupEl.style.top = (targetPos.top + $target.outerHeight()) + 'px';
                  // popupEl.style.left = (targetPos.left + $target.outerWidth()) + 'px';

                  var list = document.createElement('ul');

                  var dates = Object.values(events[full]);
                  dates.forEach(function(d) {

                    var listItem = document.createElement('li');

                    var link = document.createElement('a');
                    link.setAttribute('href', d.path);
                    link.setAttribute('target', '_blank');

                    var time = document.createElement('span');
                    time.className = "item-time";
                    time.innerText = d.time.hours + "h" + d.time.minutes;

                    var infos = document.createElement('span');
                    infos.className = "item-infos";
                    infos.innerText = d.title;


                    var type = document.createElement('span');
                    type.className = 'encart-action';

                    if (d.type === "evenement_archive" || d.type === "evenement") {

                      switch (d.category) {
                        case 3:
                          type.innerText = 'spectacle vivant';
                          break;

                        case 4:
                          type.innerText = 'cinéma';
                          break;

                        default:
                          break;
                      }


                    } else {
                      type.innerText = d.type;
                    }

                    // link.appendChild(linkTextNode);
                    infos.appendChild(type);
                    link.appendChild(time);
                    link.appendChild(infos);
                    // link.appendChild(type);
                    listItem.appendChild(link);
                    list.appendChild(listItem);

                  });

                  popupEl.appendChild(list);
                  calendarElement.appendChild(popupEl);

                  popupEl.addEventListener('mouseenter', () => {
                    popupHovered = true;
                  });

                  popupEl.addEventListener('mouseleave', () => {
                    popupHovered = false;
                    removePopup();
                  })

                }
              }

              function removePopup() {
                var popupEl = document.getElementById('calendar-popup');
                if (popupEl) popupEl.remove();
                if (activeDateEl) {
                  activeDateEl.classList.remove('active');
                  activeDateEl = null;
                }
              }

              // Make changes on the date elements
              calendar.onDateRender(function(date, element, info) {
                var full = getFullDate(date);

                element.onmouseenter = null;
                element.onmouseleave = null;

                if (events.hasOwnProperty(full)) {

                  element.className += ' has-events';
                  element.setAttribute('data-x', info.position.x);
                  element.setAttribute('data-y', info.position.y);

                  element.onmouseenter = () => {
                    setupPopup(element, date)
                  };

                  element.onmouseleave = () => {
                    dateHovered = false;

                    setTimeout(() => {
                      if (!popupHovered && !dateHovered) {
                        removePopup();
                      }
                    }, 50);
                  };
                }



              });

              // calendar.onDateClick(function(event, date) {
              //   setupPopup(event.target, date);
              // });

              calendar.onMonthChange(function(event, date) {
                removePopup();
              });

              calendar.refresh();
            }

          }

          if (!window._so_calendar_ok && window._so_events_data) {
            setupCalendar(window._so_events_data);
          }
        }

      });


      var $grid = $('.taxonomy-grid');
      if ($grid.length) {
        var grid = $grid.get(0);

        function resizeGridItem(item){
          // var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
          var rowHeight = 20;
          var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));

          var itemHeight = 0;
          $(item).children().each(function(index, child) {
            console.log('child', child);
            itemHeight += $(child).outerHeight();
            console.log('$(child).outerHeight()', $(child).outerHeight());
          });
          console.log('itemHeight', itemHeight);
          var rowSpan = Math.ceil((itemHeight)/(rowHeight));


          console.log('\n\n');
          console.log('$(item).outerHeight()', $(item).outerHeight());
          console.log('rowHeight', rowHeight);
          console.log('rowGap', rowGap);
          console.log('rowSpan', rowSpan);

          item.style.gridRowEnd = "span "+rowSpan;
        }

        function resizeAllGridItems(){
          var allItems = grid.children;
          for(var x=0;x<allItems.length;x++){
            resizeGridItem(allItems[x]);
          }
        }

        // resizeAllGridItems();
        // window.addEventListener("resize", resizeAllGridItems);
      }

      $(window).on('resize', function () {
        // Execute code when the window is resized.
      });

      $(window).on('scroll', function () {
        // Execute code when the window scrolls.
      });

    }
  };

})(Drupal, jQuery);
